import { getUserPagesQuery, getUserProfileQuery } from '@redlink/services';

export const freshCache = (cache, { data }) => {
  const freshData = data.NewPage;

  let {
    UserPages: { active: oldData, ...rest },
  } = cache.readQuery({
    query: getUserPagesQuery,
  });

  let {
    UserProfile: { availablePageCount, ...rest2 },
  } = cache.readQuery({
    query: getUserProfileQuery,
  });

  cache.writeQuery({
    query: getUserPagesQuery,
    data: {
      UserPages: { ...rest, active: [freshData, ...oldData] },
    },
  });

  cache.writeQuery({
    query: getUserProfileQuery,
    data: {
      UserProfile: { ...rest2, availablePageCount: availablePageCount - 1 },
    },
  });
};
